export const LINEAR = 'linear'
export const NONE = 'none'
export const NULL_STRING = 'null'
export const NUMBER = 'number'
export const PREVIOUS = 'previous'
